import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { OAuthAuthorizeEffects } from './store/o-auth-authorize/o-auth-authorize.effects';
import { OAuthClientEffects } from './store/o-auth-client/o-auth-client.effects';
import {
  OAuthClientNamespace,
  OAuthClientReducer,
} from './store/o-auth-client/o-auth-client.store';
import { OAuthClientAuthEffects } from './store/o-auth-client-auth/o-auth-client-auth.effects';
import {
  OAuthClientAuthNamespace,
  OAuthClientAuthReducer,
} from './store/o-auth-client-auth/o-auth-client-auth.store';
import { OAuthCountersEffects } from './store/o-auth-counters/o-auth-counters.effects';
import {
  OAuthCountersNamespace,
  OAuthCountersReducer,
} from './store/o-auth-counters/o-auth-counters.store';

@NgModule({
  imports: [
    StoreModule.forFeature(OAuthClientNamespace, OAuthClientReducer),
    StoreModule.forFeature(OAuthClientAuthNamespace, OAuthClientAuthReducer),
    StoreModule.forFeature(OAuthCountersNamespace, OAuthCountersReducer),
    EffectsModule.forFeature([
      OAuthAuthorizeEffects,
      OAuthClientEffects,
      OAuthClientAuthEffects,
      OAuthCountersEffects,
    ]),
  ],
})
export class OAuthDataModule {}
